<template>
    <div class="register">
        <!-- 入会协议-->
        <el-dialog class="dialogNotice"
                v-if="$store.state.isHouseCampaign"
                title="优秀住宅"
                :visible.sync="$store.state.isHouseCampaign"
                width="70%"
                v-cloak>
            <div class="notice-title test-1">
                <div class="article">
                    <div class="articleTitle">
                        <h2>第十二届“上海市优秀住宅”评选活动</h2>
                        <h2>实施方案</h2>
                    </div>
                    <div class="content">
                        <p>为进一步贯彻中央十四五规划和二○三五年远景目标，以习近平新时代中国特色社会主义思想为指导，全面贯彻党的十九大精神，协调推进“四个全面”战略布局、实现“两个一百年”奋斗目标的高度，落实创新、协调、绿色、开放、共享的发展理念和“人民城市人民建，人民城市为人民”的重要理念。根据市政府及市住建委“十四五”重点工作要求，聚焦住房市场体系和住房保障体系，深化以居住为主、市民消费为主、普通商品住房为主，优化廉租住房、公共租赁住房、共有产权保障住房、征收安置住房的住房保障体系，完善租购并举的住房制度。积极推进加快绿色建筑和住宅产业现代化的建设发展，全力打造绿色生态城区，推进超低能耗建筑的试点，持续深化既有建筑节能改造，走集约、智能、绿色、低碳的新型城镇化发展道路，实现城市粗放管理向城市精细治理转变。不断提升绿色建筑发展能级，赋能绿色、生态、宜居的现代化城市。第十二届“上海市优秀住宅”评选工作今年将正式开展，现将评选工作安排如下：</p>
                        <h4>一、总体要求</h4>
                        <p>第十二届“上海市优秀住宅”评选工作要遵循“中心辐射、两翼齐飞、新城发力、南北转型”的城市发展格局，坚持“经济、适用、美观、绿色”的建筑方针，充分体现连续性、公正性、权威性、导向性以及“与时俱进”的精神，全面反映近两年上海住宅建设整体质量及住宅产业化水平的提高和超低能耗建筑小区的建设，重点关注保障性安居工程项目的建设。根据住房城乡建设部等七部委《关于印发绿色建筑创建行动方案的通知》和上海市委、市政府《关于深入贯彻落实中央城市工作会议精神，进一步加强本市城市规划建设管理工作的实施意见》、《关于推进本市超低能耗建筑发展的实施意见》中对新建住宅的建设要求，推进建筑产业现代化作为建筑业适应经济发展“新常态”的发展方向。以实现住宅产业现代化为根本目标，积极推广绿色建筑和建材，推进新建住宅项目技术集成应用及产业现代化快速发展，通过加大“四新技术”和“四节一环保”产品的推广使用，通过全面推行住宅装配式和全装修，提升装配式建筑发展能级。推进超低能耗建筑试点项目的实施，加大低碳建筑推进力度，发展绿色建筑，提高住房科技含量，着力推动建筑业碳达峰和碳综合目标的达成，推动房地产行业全生命周期的发展，促进本市住宅建设平稳健康发展。</p>
                        <h4>二、奖项设置</h4>
                        <p><span>1.单项奖五项</span></p>
                        <p>（1）规划建筑奖：规划理念有创新，布局合理、功能完善、空间组合富有变化，符合节地原则，具有均好性；建筑设计注重地域文化特色和城市区域规划及总体规划相协调；建筑单体造型美观，色彩协调，符合日照、通风要求；交通组织便捷，道路分级明确；小区配套完善，有便利的对外交通，各种设施能满足不同年龄层次居民的使用要求，社区活动场所的设置充分考虑老人、儿童的需求，具有良好的居住环境；设计文本规范，表达清晰。</p>
                        <p>（2）房型设计奖：住宅设计以中小户型为主，深入细致，考虑周全，以人为本，节能省地与上海气候自然条件相适应；单元平面布局考虑各套型均好性，平面规整，户均面宽适当，兼顾节能省地和舒适要求；套内功能空间齐备，布局合理、紧凑，动静分区明确，各功能空间面积配置与套型面积协调，套内空间有效利用率高；结构体系有利于空间灵活分隔，考虑在住宅全寿命周期内可适当改造；有较好的日照、通风、采光条件，满足隔声要求。</p>
                        <p>（3）绿化环境奖：小区绿地率≥40%，硬质景观面积≤20%的绿地总面积，并倡导垂直绿化、屋面绿化等多种绿化形式；绿化配置合理，具有生态、保健、美观的效果，并提倡以本地区植物为主；绿化设计具有均好性，且主要景观的设计具有特色，与周边环境相协调；小区雕塑设计温馨、美观；住区景观设计考虑社会功能，体现对人的关怀。</p>
                        <p>（4）住宅产业化奖：按照新建住宅绿色建筑行动计划要求，积极实施绿色建筑整装成套技术和产品的创新与应用。住宅项目实施装配式住宅建设模式，项目实施面积达到装配式建设要求，采用工业化建筑结构设计、构配件生产、安装施工；积极实施智慧居住社区的建设，积极推行BIM技术的应用，信息化水平、智能化水平处于上海领先地位，建设居住需求的信息高速互联宽带网、推动网络设施和物业服务内容与应用终端融合, 提升居住信息通信设施的服务水平；全装修住房定位准确，满足《全装修室内装修设计标准》要求；室内环境舒适、美观、健康；厨卫功能完备，布置合理，使用方便；使用材料符合节能低碳要求，符合产业发展方向，现场装配化程度高；小区全装修住宅比例高，并完成一定数量的样板房。</p>
                        <p>（5）绿色低碳奖：积极实施节能环保技术，综合考虑住宅性能、资源节约利用、住宅建设成本与使用成本之间的相互关系，保证三者之间的协调；严格执行节能标准，应用新技术、新工艺、新材料、新产品及清洁能源，应用高性能节能门窗和新型保温产品，增强住宅围护结构隔热保温性能；合理利用太阳能等可再生能源与分布式能源；积极实施海绵小区建设，严格控制景观水的利用，全面使用节水型器具；积极实施超低能耗建筑建设，力求在能源供给、建筑构造、建筑设备、运行管理四大系统满足节能要求；应用可循环、高性能、低材耗、环保质优的建筑材料，加强建筑废弃物的综合利用、循环利用；健全居住区污染物减排措施，提高新建住宅室内空气质量。</p>
                        <p><span>2.综合奖两项</span></p>
                        <p>（1）上海市优秀住宅金奖</p>
                        <p style="text-indent: 4em;">参评条件：</p>
                        <p style="text-indent: 6em;">①申报四个或四个以上单项奖的楼盘；</p>
                        <p style="text-indent: 6em;">②土建工程基本完成。</p>
                        <p>（2）上海市优秀保障性住房奖：</p>
                        <p style="text-indent: 4em;">参评条件：</p>
                        <p>2021年底基本建成的建筑面积在4万平方米以上（或至少达到一个完整组团规模的）共有产权保障房、征收安置房、租赁住房、廉租房项目；</p>
                        <h4>三、评选范围</h4>
                        <p>2019年5月以后竣工及目前在建的居住区、住宅小区、街坊或团组，具体为：</p>
                        <p>1.参加“规划建筑奖”及“房型设计奖”评选的项目，须完成基础工程。</p>
                        <p>2.参加“绿化环境奖”评选的项目，小区绿化须有完整的样板区（段）。</p>
                        <p>3.参加“住宅产业化奖”评选的项目，小区装配式住宅建设项目应具备完善的实施方案；全装修住宅比例应达到要求，并建成符合试点工程要求的样板房。</p>
                        <p>4.参加“绿色低碳奖”评选的项目，须有绿色低碳等技术具体实施方案。</p>
                        <p>5.参加“上海市优秀保障性住房奖”评选的项目为本市市属和各区开发的共有产权保障房、征收安置房、租赁住房、廉租房。</p>
                        <p>在第十一届“上海市优秀住宅”评选中获单项奖的项目，符合本届评选范围的，在综合奖评选中予以承认。</p>
                        <h4>四、评选方式</h4>
                        <p>1.符合参评条件的住宅项目，由房地产开发建设单位向项目所属行政区的市房协专业委员会报名，并按参评要求提供项目相关资料，同时提供项目负责人基本资料及简介。</p>
                        <p>2.参评项目由市房协各专业委员会负责初审，在听取主管部门及有关建设管理单位的意见后推荐上报评选办公室，确认后即作为入围项目。</p>
                        <p>3.入围项目经评选专家委员会按评比标准和程序，评出候选项目。</p>
                        <p>4.对候选项目进行评审，采取专家委员会评审和市民参与评审的方式进行，其中符合综合奖条件（申报4个或4个以上单项奖）的候选项目，专家进行有重点的现场踏勘，并进行综合评审推荐出各奖项的获奖项目。同时，候选项目将全部公开展示公告，听取市民意见，接受市民监督。</p>
                        <p>5.评审综合意见报评选办公室审定后，作为最终获奖项目。</p>
                        <h4>五、评选组织机构</h4>
                        <p>本届评选活动由上海市房地产行业协会主办，上海市住房和城乡建设管理委员会、上海市规划和自然资源局、上海市房屋管理局作为支持单位。</p>
                        <p><span>1、评选办公室</span></p>
                        <p class="title">主  任：</p>
                        <p style="text-indent: 6em;">赵龙杰&emsp;上海市房地产行业协会秘书长</p>
                        <p class="title">副主任：</p>
                        <p style="text-indent: 6em;">荣蕴倩&emsp;上海市房地产行业协会副秘书长</p>
                        <p class="title">成  员：</p>
                        <p style="text-indent: 6em;">季&emsp;明、陆剑峰、彭伟军、郭晓赟、阮玉薇、黄梦靓、朱卫平</p>
                        <p><span>2、评选专家委员会</span></p>
                        <p class="title">主  任：</p>
                        <p style="text-indent: 6em;">孙&emsp;勇&emsp;上海市房地产行业协会副秘书长</p>
                        <p class="title">委  员：</p>
                        <p style="text-indent: 6em;">胡克敏&emsp;原上海中星集团董事长</p>
                        <p class="title">主  任：</p>
                        <p style="text-indent: 6em;">王建强&emsp;同济大学建筑设计研究院副总建筑师、教授级高级建筑师</p>
                        <p style="text-indent: 6em;">余文浩&emsp;上海市住宅建设发展中心总工程师、高级工程师</p>
                        <p style="text-indent: 6em;">张&emsp;凡&emsp;同济大学建筑城规学院副教授、博士</p>
                        <p style="text-indent: 6em;">夏&emsp;翀&emsp;上海开艺设计集团有限公司总工程师、教授级高级工程师</p>
                        <p style="text-indent: 6em;">周如雯&emsp;上海市风景园林学会副理事长兼秘书长、高级工程师</p>
                        <p style="text-indent: 6em;">范善华&emsp;上海市园林设计研究总院副总工程师、教授级高级工程师</p>
                        <p style="text-indent: 6em;">赵为民&emsp;上海市房地产科学研究院总工程师、教授级高级工程师</p>
                        <p style="text-indent: 6em;">徐&emsp;强&emsp;上海市建筑科学研究院总工程师、教授级高级工程师</p>
                        <p style="text-indent: 6em;">胡&emsp;煜&emsp;上海市住宅建设发展中心、高级工程师</p>
                        <p style="text-indent: 6em;">蔡俊坚&emsp;中国建筑标准设计院有限公司上海分公司院长、高级工程师</p>
                        <p style="text-indent: 6em;">姚&emsp;臻&emsp;上海市房屋状况信息中心副主任</p>
                        <p style="text-indent: 6em;">张剑俊&emsp;上海市房地产行业协会建筑节能推广专业委员会秘书长、bSI国际大奖赛评委、上海市BIM推广中心专家</p>
                        <h4>六、评选活动时间安排</h4>
                        <p>1、自6月25日起市房协各专业委员会接受房地产开发建设单位报名，报名截止至7月25日。</p>
                        <p>2、参评项目由市房协各专业委员会负责联合初审，并听取有关单位意见后于8月15日之前按参评要求汇总相关资料推荐上报评选办公室，确认后即作为入围项目。</p>
                        <p>3、8月25日前入围项目经评选专家委员会按评比标准和程序评出候选项目。</p>
                        <p>4、8月25日至9月25日专家委员会对候选项目进行综合评审。</p>
                        <p>5、候选项目于10月在上海房协网站（www.srea.org.cn）、微信公众号和上海市房地产行业协会举办的相关展会上专题展示，接受市民和专家点评。</p>
                        <p>6、11月评审综合意见报评选办公室审定，12月公布评选结果。</p>
                        <p>7、届时完成第十二届“上海市优秀住宅”评选获奖作品集的编辑工作。</p>
                        <h4>七、参评项目需提供的资料</h4>
                        <p>1.报名表（可在上海房协网站www.srea.org.cn查询并下载，请按要求准确填写，尤其是楼盘、单位名称应完整无误）。</p>
                        <p>2.光盘资料（2份），包括文字和图片资料制作成光盘上报。</p>
                        <h4>八、参评项目制作内容及要求</h4>
                        <p><span>1.申报“上海市优秀住宅金奖”具体内容</span></p>
                        <p>（1）总体概述：文字资料（1000-1500字）包括参评单位简介；设计单位名称；施工单位名称；物业管理单位名称（请完整、准确填写名称）；建设周期（开工、竣工日期）；相关经济技术指标；申报奖项的项目特点及主要设计理念等。（如有企业标志或楼盘标志，请在上报资料中注明）</p>
                        <p>（2）分项说明（按申报奖项分别说明）：</p>
                        <p style="text-indent: 3em;">①规划建筑奖：</p>
                        <p>文字资料（800-1000字）包括规划、建筑设计理念。图纸、实景照片（或效果图）：提供小区总平面图1张；道路、绿化规划分析图各1张；小区公建配置图1张；小区总体鸟瞰图、实景鸟瞰照片3—4张；单体立面图2—3张、立面效果图或照片3—4张；各向立面图、剖面图各1张；单体建筑的标准层平面图。（图纸需标注尺寸）。</p>
                        <p style="text-indent: 3em;">②房型设计奖：</p>
                        <p>文字资料（800-1000字）包括房型设计理念说明；房型图纸、实景照片（或效果图）；提供房型平面图1张；房型布置平面图1张（图纸需标注尺寸）。</p>
                        <p style="text-indent: 3em;">③绿化环境奖：</p>
                        <p>文字资料（800-1000字）包括小区绿化配置说明。图纸、实景照片（或效果图）：提供小区总平面图1张；小区绿化布置平面图1张；小区实景鸟瞰照片2—3张；小区主要景观照片3—6张；水资源、生物资源的保护与利用方面的相关资料或照片若干；绿化布局的分析图1张。</p>
                        <p style="text-indent: 3em;">④住宅产业化奖：</p>
                        <p>小区总平面图1张，在总平面图上标明：</p>
                        <p>a.装配式住宅位置、户数；</p>
                        <p>b.全装修房位置、户数，全装修房的设计图纸全套（平面布置图、内墙立面图、顶棚设计图、样板房实景图、装修造价等），全装修室内效果图或实景图，装修材料列表，装修设计说明、项目进展情况等文字说明；</p>
                        <p>c.装配式住宅和智慧居住社区的建设提交具体实施方案。</p>
                        <p style="text-indent: 3em;">⑤绿色低碳奖：</p>
                        <p>文字资料（800-1000字）包括绿色低碳技术应用内容清单及实施方案；反映绿色低碳技术应用的照片若干张；有关鉴定情况的证明复印件和数据说明。</p>
                        <p>（3）相关文件</p>
                        <p>①建设项目选址意见书复印件</p>
                        <p>②建设用地规划许可证复印件</p>
                        <p>③建设工程规划许可证复印件</p>
                        <p><span>2. 申报“上海市优秀保障性住房奖”具体内容</span></p>
                        <p>（1）总体概述：</p>
                        <p>文字资料（1000-1500字）包括参评单位简介；设计单位名称；施工单位名称；物业管理单位名称（请完整、准确填写名称）；建设周期（开工、竣工日期）；相关技术经济指标；申报奖项的项目特点及主要设计理念等。（如有企业标志或楼盘标志，请在上报资料中注明）</p>
                        <p>（2）分项说明（按申报奖项分别说明）：</p>
                        <p>①规划建筑奖：</p>
                        <p>文字资料（800-1000字）包括规划、建筑设计理念。图纸、实景照片（或效果图）：提供小区总平面图1张；道路、绿化规划分析图各1张；小区公建配置图1张；小区总体鸟瞰图、实景鸟瞰照片3—4张；单体立面图2—3张、立面效果图或照片3—4张；各向立面图、剖面图各1张；单体建筑的标准层平面图。（图纸需标注尺寸）。</p>
                        <p>②房型设计奖：</p>
                        <p>文字资料（800-1000字）包括房型设计理念说明；房型图纸、实景照片（或效果图）；提供房型平面图1张；房型布置平面图1张（图纸需标注尺寸）。</p>
                        <p>③绿化环境奖：</p>
                        <p>文字资料（800-1000字）包括小区绿化配置说明。图纸、实景照片（或效果图）：提供小区总平面图1张；小区绿化布置平面图1张；小区实景鸟瞰照片2—3张；小区主要景观照片3—6张；水资源、生物资源的保护与利用方面的相关资料或照片若干；绿化布局的分析图1张。</p>
                        <p>④住宅产业化奖：</p>
                        <p>小区总平面图1张，在总平面图上标明：</p>
                        <p>a.装配式住宅位置、户数；</p>
                        <p>b.全装修房位置、户数，全装修房的设计图纸全套（平面布置图、内墙立面图、顶棚设计图、样板房实景图、装修造价等），全装修室内效果图或实景图，装修材料列表，装修设计说明、项目进展情况等文字说明；（仅限租赁住房）</p>
                        <p>c.装配式住宅和智慧居住社区的建设提交具体实施方案。</p>
                        <p>⑤绿色低碳奖：</p>
                        <p>文字资料（800-1000字）包括绿色低碳技术应用内容清单及实施方案；反映绿色低碳技术应用的照片若干张；有关鉴定情况的证明复印件和数据说明。</p>
                        <p>（3）相关文件</p>
                        <p>①建设项目选址意见书复印件</p>
                        <p>②建设用地规划许可证复印件</p>
                        <p>③建设工程规划许可证复印件</p>
                        <p>3.具体格式要求</p>
                        <p>（1）申报表统一采用A4纸张，并在光盘中提供word格式电子文档；</p>
                        <p>（2）光盘统一采用PPT格式刻录；</p>
                        <p>（3）文字说明要言简意赅，要按照奖项评审要求进行阐述，要反映小区实质内容。文字全部采用四号仿宋体；</p>
                        <p>（4）实景照片清晰度要高(350dpi以上分辨率,要求电子分色)，注意拍摄的角度，采用JPEG格式。</p>
                        <p>（5）尽可能采用实景照片，未建成的项目或无法用照片表达的内容可采用彩色效果图代替（精确度要高）。</p>
                        <p>（6）每张照片应附有相应的文字说明。</p>
                        <h4>九、费用</h4>
                        <p>第十二届“上海市优秀住宅”评选不收取报名费和参赛费。</p>
                        <p>在上海市房地产行业协会举办的相关展会中展示的费用、公告和获奖项目牌证制作以及《第十二届“上海市优秀住宅”评选获奖作品集》的编辑等费用按成本收取代办费。</p>
                        <p>评选办公室设在上海市房地产行业协会。</p>
                        <p>地址：浦东新区南泉北路201号（房地大厦）1205室（邮编：200120）</p>
                        <p>联系人：季明、阮玉薇、黄梦靓</p>
                        <p>联系电话：50395273、58387032</p>
                        <p>传  真：50897679</p>

                    </div>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="remove">取 消</el-button>
                <el-button @click="confirm">报 名</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'HouseCampaign',
  data() {
    return {

    }
  },
  methods:{
    // 取消
    remove(){
        this.$store.commit("getHouseCampaign", false);
    },
    // 跳转活动评选
    confirm(){
        window.location.href=process.env.VUE_APP_BASE_URL_API+'/nkyxf/nav/px-house-apply-t/my-list';
    },
  }
}
</script>

<style scoped>
:deep(.el-dialog) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    overflow: hidden;
}

:deep(.el-dialog__header) {
    padding: 20px;
    width: 100%;
    text-align: center;
    font-weight: 600;
    background-color: #f2f2f2;
}

:deep(.el-dialog__body) {
    padding: 30px;
    width: 100%;
}

.notice-title {
    width: 100%;
    height: 60vh;
    font-size: 14px;
    line-height: 38px;
    text-align: left;
    overflow: hidden;
    overflow-y: scroll;
}

/* .notice-title p {
    margin-bottom: 12px;
    font-size: 1em;
    letter-spacing: 1px;
    line-height: 32px;
    word-break: break-word;
    overflow-wrap: break-word;
} */

.article .articleTitle {
    margin-bottom: 20px;
}

.test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}

.test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: var(--bg-color-4);
}

.test-1::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: #f2f2f2;
}

.note-frame {
    width: 100%;
    border: none;
    height: 100%;
}
:deep(.el-dialog__footer){
    padding: 0px 20px 20px;
    width: 100%;
}
.dialog-footer{
    display: inline-block;
    width: 100%;
    text-align: center;
}
.dialog-footer .el-button {
    width: 30%;
    background-color: var(--bg-color);
    border-color: var(--bg-color);
    color: #fff;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -moz-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -ms-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.dialog-footer .el-button:hover {
  background-color: var(--bg-color-8);
  border: 1px solid var(--bg-color-8);
  color: var(--text-light-color);
}
.dialog-footer .el-button:first-child {
    margin-right: 12%;
    background-color: #fff;
    border: 1px solid #DCDFE6;
    color: #606266;
}
.dialog-footer .el-button:first-child:hover {
  background-color: var(--bg-color);
  color: var(--text-light-color);
}
</style>
